// @flow strict
import { Button, Modal, Tooltip, message } from 'antd';
import React, { useState } from 'react';
import { FaUserEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa6";
import { IoPlay } from "react-icons/io5";
import { RiPauseLine } from "react-icons/ri";
import { TiCancel } from "react-icons/ti";
import { useNavigate } from 'react-router-dom';
import { adminCancelSubscription, pauseSubscription, resumeSubscription } from '../../../api/pricing';
import SubscriberInfo from './SubscriberInfo';
import UpdateSubscriberInfo from './UpdateSubscriberInfo';

function SingleSubscriber({ subscriber }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false);
  const navigate = useNavigate();

  const handleClickPause = () => {
    Modal.confirm({
      title: 'Pause Subscription Plan',
      content: <p className="mb-3">{`Are you sure you want to pause this subscription plan?`}</p>,
      okText: "Pause Now",
      cancelText: 'Cancel',
      onOk: handlePauseSubscription,
      okType: "danger",
    });
  };

  const handleClickResume = () => {
    Modal.confirm({
      title: 'Resume Subscription Plan',
      content: <p className="mb-3">{`Are you sure you want to resume this subscription plan?`}</p>,
      okText: "Resume Now",
      cancelText: 'Cancel',
      onOk: handleResumeSubscription,
      okType: "primary",
    });
  };

  const handleClickCancel = () => {
    Modal.confirm({
      title: 'Cancel Subscription Plan',
      content: <p className="mb-3">{`Are you sure you want to cancel this subscription plan?`}</p>,
      okText: "Cancel Now",
      cancelText: 'Cancel',
      okType: "danger",
      onOk: handleCancelSubscription,
    });
  };

  const handlePauseSubscription = async () => {
    try {
      const res = await pauseSubscription(subscriber?.company._id);

      message.success(res.data?.message || "Subscription paused successfully");
      navigate(0);
    } catch (error) {
      console.log(error);
      message.error("Failed to pause subscription");
    };
  };

  const handleResumeSubscription = async () => {
    try {
      const res = await resumeSubscription(subscriber?.company._id);

      message.success(res.data?.message || "Subscription resumed successfully");
      navigate(0);
    } catch (error) {
      console.log(error);
      message.error("Failed to resume subscription");
    };
  };

  const handleCancelSubscription = async () => {
    try {
      const res = await adminCancelSubscription(subscriber?.company._id);
      message.success(res.data?.message || "Subscription canceled successfully");
      navigate(0);
    } catch (error) {
      console.log(error);
      message.error("Failed to cancel subscription");
    };
  };

  return (
    <div>
      <div className="gap-2 d-flex justify-content-center">
        <Tooltip title="View Subscription" color="grey">
          <Button
            onClick={() => setIsModalOpen(true)}
          >
            <FaEye size={16} />
          </Button>
        </Tooltip>
        <Tooltip title="Update Subscription" color="cyan">
          <Button
            disabled={subscriber?.status !== "active"}
            onClick={() => setIsOpenUpdateModal(true)}
          >
            <FaUserEdit size={16} />
          </Button>
        </Tooltip>
        {
          subscriber?.status === "paused" ?
            <Tooltip title="Resume Subscription" color="gold">
              <Button onClick={handleClickResume}>
                <IoPlay size={16} />
              </Button>
            </Tooltip>
            :
            <Tooltip title="Pause Subscription" color="gold">
              <Button
                disabled={subscriber?.status !== "active"}
                onClick={handleClickPause}
              >
                <RiPauseLine size={16} />
              </Button>
            </Tooltip>
        }

        <Tooltip title="Cancel Subscription" color="red">
          <Button
            danger
            disabled={subscriber?.status !== "active"}
            onClick={handleClickCancel}
          >
            <TiCancel size={16} />
          </Button>
        </Tooltip>
      </div>

      <Modal
        title={subscriber?.companyName}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={false}
      >
        <SubscriberInfo subscriber={subscriber} />
      </Modal>

      <Modal
        title="Update Subscription"
        open={isOpenUpdateModal}
        onCancel={() => setIsOpenUpdateModal(false)}
        footer={false}
      >
        <UpdateSubscriberInfo
          subscriber={subscriber}
          setIsOpenUpdateModal={setIsOpenUpdateModal}
        />
      </Modal>
    </div >
  );
};

export default SingleSubscriber;